// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import 'es6-promise/auto'
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import * as types from "@/store/types";
import config from "@/config";
import eventBus from "@/libs/event-bus"; // for event

// only dev mode
if (process.env.NODE_ENV !== "production") require("@/libs/debugger");

// ui framework
/*import iView from 'iview'
import 'iview/dist/styles/iview.css'
import locale from 'iview/dist/locale/en-US'*/

//ui framework update to version 4
import ViewUI from "view-design";
import locale from "view-design/dist/locale/en-US";
import "view-design/dist/styles/iview.css";

//Import DataTable
import VueGoodTablePlugin from "vue-good-table";
// import the styles
import "vue-good-table/dist/vue-good-table.css";

// lib
import md5 from "js-md5";
import lodash from "lodash";

// more import, please checkout @/page/dashboard/index

require("@/mock");

Vue.use(ViewUI, { locale });
Vue.use(VueGoodTablePlugin);

/**
 * @description 全局注册应用配置
 */
Vue.prototype.$config = config;
// event bus
Vue.prototype.$bus = eventBus;
// lodash / _
Vue.prototype.$lodash = lodash;
// store types
Vue.prototype.$types = types;
// md5 lib
Vue.prototype.$md5 = md5;

// get settings
let settingsString = localStorage.getItem(config.SETTING_KEY);
let settings = {};
if (settingsString && settingsString.length) {
  try {
    let s = JSON.parse(settingsString);
    if (lodash.isObject(s)) settings = s;
  } catch (err) {}
}

Vue.prototype.$settings = settings;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },

  mounted() {
    document.title = config.title;
  },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js